export interface SubscriptionPlanDetailsDto
{

    getTitle(): string;
    getDescriptionList():string[];
}

export class SubscriptionPlanDetailsDtoImpl implements SubscriptionPlanDetailsDto
{
    private subsciptionPlanDetailsTitle: string;
    private subscriptionPlanDetailsDescription: string[] = [];

    getTitle(): string 
    {
        return this.subsciptionPlanDetailsTitle;
    }
    setTitle(subsciptionPlanDetailsTitle: string)
    {
        this.subsciptionPlanDetailsTitle = subsciptionPlanDetailsTitle;
    }

    getDescriptionList(): string[]
    {
        return this.subscriptionPlanDetailsDescription;
    }
    setDescriptionList(subscriptionPlanDetailsDescription: string[])
    {
        this.subscriptionPlanDetailsDescription = subscriptionPlanDetailsDescription;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/subscriptionplandetails/subscriptionplandetailsdto.tsx